import React from 'react';
import { CheckIcon } from 'lucide-react';
import { INCLUDED_ITEMS } from '../data/content';
import { Overline } from './Overline';
const GALLERY_WIDE = 'https://cdn.magicpatterns.com/patterns/generated-images/66058f65-ce6b-452c-9b42-ff254423deb0.jpg';
export function IncludedSection() {
  return <section className="bg-cream py-24 lg:py-32" data-id="element-288" data-mp="3cdpm4xr8gamm">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-289" data-mp="3cgbpsmb065zk">
        <div className="grid items-start gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-290" data-mp="3zgx1znx61z7">
          <div className="lg:col-span-5" data-id="element-291" data-mp="80iymn5b6q4c">
            <Overline data-id="element-292" data-mp="7zhockw4a7no">Qué incluye</Overline>
            <h2 className="mt-6 font-serif text-[2rem] font-light leading-[1.12] text-ink sm:text-[2.5rem]" data-id="element-293" data-mp="3qe8p3qgucqhx">
              No solo instalamos suelo. Resolvemos todo lo que hace que el resultado se vea
              perfecto.
            </h2>
            <div className="mt-10 overflow-hidden rounded-3xl" data-id="element-294" data-mp="mwi4rs8uyg6u">
              <img src={GALLERY_WIDE} alt="Pasillo reformado con tarima de roble y puertas nuevas" className="h-full w-full object-cover" data-id="element-295" data-mp="rnqhoy9ecjor" />
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7" data-id="element-296" data-mp="3mgtuetrrhnh2">
            <ul className="divide-y divide-ink/10 border-y border-ink/10" data-id="element-297" data-mp="419lcisfk72k">
              {INCLUDED_ITEMS.map(item => <li key={item} className="flex items-center gap-4 py-5" data-id="element-298" data-mp="3vfywub6g20yi">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-champagne/60" data-id="element-299" data-mp="dzgzyuz8yd1e">
                    <CheckIcon className="h-3.5 w-3.5 text-walnut" aria-hidden="true" data-id="element-300" data-mp="8zkussetcfk9" />
                  </span>
                  <span className="font-serif text-xl font-light text-ink" data-id="element-301" data-mp="mz43pnfg7uxm">{item}</span>
                </li>)}
            </ul>
            <p className="mt-8 text-[13px] leading-relaxed text-stone-600" data-id="element-302" data-mp="hzhq3cvpkcoa">
              Todo queda reflejado por partidas en el presupuesto cerrado, así sabes exactamente qué
              está incluido antes de que entremos en tu vivienda.
            </p>
          </div>
        </div>
      </div>
    </section>;
}